//BEGIN Tobacco Conditions

define([], function() {	

var TOBACCO = {
	init : function() {
        $("#ProductForm input[name='tobacco-more']").unbind('click').click(function () {
        	TOBACCO.tobaccoModal();
        });
        if($('#cartbodyBD').val() == 'true'){
        	TOBACCO.warningNofication();
		}
        $.each( $('.product-tile-set'), function( index,value ) {
        	TOBACCO.searchDisplayRules(index,value );
    		
        });
        
	},
	searchDisplayRules : function(index,value ) {
		var status = COSTCO.TOBACCO.userMemberInfo();
		var hasLicense = status.hasLicense!='undefined'?status.hasLicense:false;
		var userInfo = COSTCO.util.getMemberCookie();
		var signedIn = userInfo.signedIn;
		var deptNumber = ($(value).find('#deptNumber').val() == "11");
		var tobaccoInState = ($(value).find('#tobaccoInState').val() == "true") ? true : false;
		var ebbProduct = ((tobaccoInState) && ($(value).find('#ebbProd').val() == "EBB") && deptNumber) ? true : false;
		var tobaccoProduct = $(value).find('#tobaccoProd').val()== "Tobacco" ? true : false;
		tobaccoProduct = (tobaccoProduct || ebbProduct ) ? true : false; 
		var addtoCart =  $(value).find('#add_Button').val();
		var inStock = parseInt($(value).find('#in_Stock').val());
		var signInDetails =  $(value).find('#signInDetails').val()=="signin-details"?true:false;
		if(tobaccoProduct) {    // tobacco product 
			if(signedIn) {  
				$(value).find('#plp-sign-in-for-details').hide();
				if (hasLicense) { 
					if(inStock > 0){
						$(value).find("#plp-more-details").hide();
						$(value).find('#plp-add-to-cart').show();
					}
					else{
					
						$(value).find('#plp-add-to-cart').remove();
						$(value).find("#plp-more-details").show();
					}
				}
				else{
					$(value).find('#plp-add-to-cart').remove();
					$(value).find("#plp-more-details").show();
				}
			}
			else{
				var zipcode = $.cookie('WC_BD_ZIP');
				if(zipcode!= null) {
					$(value).find('#plp-add-to-cart').remove();
					$(value).find("#plp-more-details").hide();
					$(value).find('#plp-sign-in-for-details').show();
				}
				else { 
					$(value).find('#plp-add-to-cart').remove();
					$(value).find('#plp-sign-in-for-details').hide();
					$(value).find("#plp-more-details").show();
				}
			}
			
		}else if(signInDetails && !signedIn){
			//map Items will come here
			$(value).find('#plp-add-to-cart').hide();
			$(value).find('#plp-sign-in-for-details').show();
			$(value).find("#plp-more-details").hide();
		}else {
			if(addtoCart == "true"){
				$(value).find('#plp-add-to-cart').show();
				$(value).find('#plp-sign-in-for-details').hide();
				$(value).find("#plp-more-details").hide();
				$(value).find('#btnas').removeClass('hide');
			}else if(inStock == 0){
				$(value).find('#plp-add-to-cart').remove();
				$(value).find('#plp-sign-in-for-details').hide();
				$(value).find("#plp-more-details").show();
			}
			else{
				$(value).find('#plp-add-to-cart').remove();
				$(value).find('#btnas').removeClass('show');
				return true;
			}
		}
			
		$(value).find('#btnas').removeClass('hide');
	},
	processConditions : function() {
		var w = COSTCO.util.getBDZipCookie();
		if (w.zipCode.length > 0) {
			var status = TOBACCO .userMemberInfo(), signedIn = status.signedIn, hasLicense = status.hasLicense;
			if (signedIn != 'undefined' && hasLicense != 'undefined') {
				TOBACCO.toggleProductView(signedIn,hasLicense);
			} else if (signedIn == 'undefined' && hasLicense == true) {
				TOBACCO.toggleProductView(false,true);
			} else if (signedIn == false && hasLicense == 'undefined') {
				TOBACCO.toggleProductView(false,false);
			} else {
				TOBACCO.ajaxMemberStatusView(signedIn,hasLicense);
			}
		}
	},
	userMemberInfo : function () {

		var t = getTobCookie(); h = $.cookie('hashedUserId'), p = $.cookie('rrDisabledPref'), r = $.cookie('rrStoreFlag');
		if ((h != null && h == '""') || (h == null && p == null && r == null) || (h == null && ((p != null && p == '""') || (r != null && r == '""')))) {
			var isSignedIn = false;
		} else if ((h != null & h != '""') || (h == null && (p != null && p != '""') && (r != null && r != '""'))) { 
			var isSignedIn = true;
		} else {
			var isSignedIn = 'undefined';
		}
		var hasLicense = t.tobLicense;
		if (hasLicense !== 'undefined') {
			hasLicense = (hasLicense == '1') ? true : false;
		}
		//Test Data 
		// hasLicense = false;
		return {signedIn : isSignedIn, hasLicense : hasLicense};
	},
	signInReferrer : function(url) {
		var baseURL = url.split('&URL=')[0],
		href = baseURL+'&URL='+encodeURIComponent(window.location.href);
		window.location.href = href;
	},
	openFormWeb : function() {
			window.open("/wcsstore/CostcoUSBDCatalogAssetStore/Tobacco/TobaccoFormWeb.pdf", "_blank");
	},
	navigateToShoppingCart : function(shoppingCartUrl) {
			var c = getTobCookie();
			var newCookieValue = c.tobLicense + "_1_1";
			$.cookie("wc_tob",newCookieValue);
			window.location.href = shoppingCartUrl;
	},
	ajaxMemberStatusView : function(signedInCookie,tobCookie){
			var tobCookieData = "&cmSignedIn=" + signedInCookie + "&cmStatus=" + tobCookie;
			$.ajax({
				type: 'GET',
				url: '/MemberStatusView',
				data: tobCookieData,
				dataType: 'json',
				success: function(data) {
					if (data != null) {
						TOBACCO .toggleProductView(data.signedIn,data.hasLicense);
					} else {
						if (signedInCookie == true) {
							TOBACCO.toggleProductView(true,false);
						} else {
							TOBACCO.toggleProductView(false,false);
						}
					}
				},
				error: function(message) {
					if (signedInCookie == true) {
						TOBACCO.toggleProductView(true,false);
					} else {
						TOBACCO.toggleProductView(false,false);
					}
				}
			})
	},
	toggleProductView : function(isSignIn, hasLicense) {
		if (hasLicense == false) {
			var tobData = $('[data-product="tobacco"]');
			tobData.find('.product').hide();
			tobData.find('#nonAddToCartBtn').hide();
			tobData.find('#addToCartBtn').hide();
			tobData.find('.product-quantity').hide();
			tobData.find('merchandisingText').hide();
			tobData.find('.tobMoreDetails').show();
			tobData.find('.addToCartContainer').attr('style', 'margin-bottom:49px;');
			tobData.find('.promotion').hide();
			if (isSignIn == false) {
				tobData.find('.tobMoreDetails').hide();
				tobData.find('.tobSignIn').show();
			}
		}
	},
	warningNofication : function () {
		var t = getTobCookie(); inCart = t.tobInCart; tc = t.agreeTobTermCond;
		if ((inCart !== 'undefined' && inCart == 1) && (tc !== 'undefined' && tc == 0)) {
			//data to put in the modal popup
			var modalHtml = $('#tmpl_cart_tob_warning_pop').html();
			var modalText = $(modalHtml).find('.text');
			$('#costcoModal').hide();
			COSTCO.dialog.createExtDialogBox({
				title :  messages.TOBACCO_NOTIFICATION_CART,
				body : modalText,
				primary: messages.TOBACCO_NOTIFICATION_ACCEPT,
				primary_event: function(){
					TOBACCO.navigateToShoppingCart();
				},
				onshown : function(e){
					$('.close').remove();
					//To avoid closing popup on clicking outside
					$(e.currentTarget).on('hide.bs.modal', function() {
						return false;
			        });
				}
			});
		}
	},
	tobaccoModal : function() {
		COSTCO.dialog.createExtDialogBox({
	        title: messages.TOBACCO_CONFIRM_YOUR_ACTION,
	        body: COSTCO.util.tmpl('tmpl_tobacco_popups'),
	        primary: messages.TOBACCO_CONTINUE_TO_FORM,
			secondary: messages.TOBACCO_CANCEL,
			primary_event: function(){
				TOBACCO.openFormWeb();
		}
	      });
	},
	navigateToShoppingCart : function() {
		var c = getTobCookie();
		var newCookieValue = c.tobLicense + "_1_1";
		$.cookie("wc_tob",newCookieValue);
		window.location.href = $("#ShoppingCartUrl").val();
	}
	
};
//END Tobacco Conditions

if(typeof window.COSTCO == 'undefined'){
    window.COSTCO = new Object();
}
window.COSTCO.TOBACCO = TOBACCO;

return TOBACCO;

});
  
function getTobCookie() {
	var wcTobCookie = $.cookie('wc_tob');
	if (wcTobCookie==null || wcTobCookie==undefined) { wcTobCookie = "undefined_undefined_undefined";}
	tobArray = wcTobCookie.split("_");
	return {tobLicense : tobArray[0], agreeTobTermCond: tobArray[1], tobInCart : tobArray[2]};
}



// WEBPACK FOOTER //
// ./js/global/tobacco.js